import * as React from 'react';
import { Box, Dialog, Grid } from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { useState } from "react";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
//import TextField from "@material-ui/core/TextField";
import dayjs from "dayjs";
import { useSnackbar } from 'notistack';
import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import { traducirButton, traducirLabel, traducirMessage } from  '../../blocks/traductor';
import us from "date-fns/locale/en-US";
import es from "date-fns/locale/es";
import useCommonApi from "../../api/useCommonApi";
import { ApplicationState } from '../../redux/reducers';
import { connect } from "react-redux"
import { IFechaFestiva } from '../../entities/catalogos/IFechaFestiva';
import { useZonaHoraria } from '../../contextos/zonaHorariaContext';
import LoadingDialog from '../controls/LoadingDialog';


interface IDialogDateProps {
    value?: Date;
    abierto: boolean;
    minDate: string;
    onClose: () => void;
    onSave: (date: Date | null) => void;
    horarios?: any;

    esOrigen: boolean;
    aplicaReglasVentana: boolean;
    ventanaFija : any,
    areaServicioRemitente: any,
    horariosAreaServicio?: any,
    esSolicitud?: boolean
}

interface StateProps {
    diasFestivos: IFechaFestiva[]
}

interface ParametroConfig {
    parametroId: number;
    valor: string;
}

type Props = StateProps & IDialogDateProps

const PickUpDate = ({ value, abierto, minDate, onClose, onSave, horarios, esOrigen, aplicaReglasVentana, ventanaFija, areaServicioRemitente, horariosAreaServicio, diasFestivos, esSolicitud  }: Props) => {
    const getDefaultDate = () => {
        const base = value ? dayjs(value) : dayjs();
        // Si es sábado, avanzar al lunes siguiente
        if (base.day() === 6) return base.add(2, 'day');
        return base;
    };
    const defaultDate = getDefaultDate();
    const [selectedDate, setSelectedDate] = useState(defaultDate.format('YYYY-MM-DDTHH:mm'));
    const { enqueueSnackbar } = useSnackbar();
    const { zonaHoraria, setZonaHoraria } = useZonaHoraria();
    const apiSource = useCommonApi();
    const [arrayDiasFestivos, setArrayDiasFestivos] = useState(new Array);
    const [showLoading, setLoading] = useState(false);
    const [parametrosFinSemana, setParametrosFinSemana] = useState<ParametroConfig[]>([]);
    // const handleDateChange = (event: ChangeEvent<HTMLInputElement>) => {
    //     setSelectedDate(event.target.value);
    // };

    React.useEffect(() => {
        if (abierto && areaServicioRemitente && areaServicioRemitente?.sucursal && (zonaHoraria.gmt === 0 || zonaHoraria.areaServicio !== areaServicioRemitente?.sucursal.id )) {
            getZonaHoraria().then(res => {
                if (res !== null && res.zona !== '') {
                    setZonaHoraria({ zona: res.zona, gmt: res.gmt, areaServicio: areaServicioRemitente?.sucursal?.id });
                }
            });


        }

    }, [value, abierto]);
    
    React.useEffect(() => {
        const parsearFecha = (d) => {
            let [dia, mes, anio] = d.fecha.split('/');
            return new Date(`${anio}-${mes}-${dia}T00:00:00`);
         };

        const fechasActuales = diasFestivos.map(parsearFecha);

        if(!esSolicitud && !esOrigen){
            setArrayDiasFestivos(fechasActuales);
        }
        else{
            getDiasInhabilProximos().then(res => {                 
                const fechasNuevas = res.map(parsearFecha);
                setArrayDiasFestivos([...fechasActuales, ...fechasNuevas]);
            });
         getParametroFinDeSemana().then(res => {
                const parametrosLimpios = res.map(param => ({
                    parametroId: param.parametroId,
                    valor: param.valor
                }));
                setParametrosFinSemana(parametrosLimpios);
            });
        }
    }, [diasFestivos]);

    const getZonaHoraria = async () => {
        const result = await apiSource.obtenerAsync<any>("solicitud-servicio/get-zona-horaria/" + areaServicioRemitente?.sucursal?.id, {username: localStorage.getItem("usuario_nombre")});
        return result;
    };

     const getDiasInhabilProximos = async () => {
        const result = await apiSource.postAsync<any>("solicitud-servicio/dias-inhabil-proximos",{username: localStorage.getItem("usuario_nombre")});
        return result;
    };

    const getParametroFinDeSemana = async () => {
        const result = await apiSource.postAsync<any>("solicitud-servicio/parametro-fin-de-semana",{username: localStorage.getItem("usuario_nombre")});
        return result;
    };
    
    const handleDateTimeChange = (date: string) => {
        let dateSelect = new Date(date);
        dateSelect.setHours(0,0,0,0);
        let esFestivo = false;
        arrayDiasFestivos.forEach((dia) => {
            if(dateSelect.getTime() === dia.getTime()){
                esFestivo = true;
                return;
            }
        });
        if(esFestivo){
            return;
        }
        setSelectedDate(date);
    };

    const saveDate = () => {
        let selectedDateNumber = new Date(selectedDate).getDate();
        let actualDate = new Date();
        let diaSemana = new Date(selectedDate).getDay();
        let actualTimezone = actualDate.toLocaleTimeString('es', {timeZone: zonaHoraria.zona.toString()});
        let hourTimeZone = actualTimezone.split(":")[0];
        let minuteTimeZone = actualTimezone.split(":")[1];
        let horaUsuario = new Date(actualDate.getFullYear(), Number(actualDate.getMonth() + 1), actualDate.getDate(), Number(hourTimeZone), Number(minuteTimeZone));

        if (!selectedDate) {
            enqueueSnackbar(traducirLabel(136), //"Fecha no válida.", 
                { variant: "error" });
            return false;
        }

       if (!esSolicitud && (diaSemana === 0 || diaSemana === 6)) {   
            let error = traducirMessage(43).replace('#####', areaServicioRemitente.nombre).replace('#####', getDiasServiciosArea());
            //`El área de servicio ${areaServicioRemitente.nombre} solo cuenta con servicio los días ${getDiasServiciosArea()}. Favor de seleccionar otra fecha.`
            enqueueSnackbar(error, {variant: "error"});
            return;
        }

        if (new Date(selectedDate) < new Date() || new Date(selectedDate).getFullYear() < new Date().getFullYear()) {
            enqueueSnackbar(traducirLabel(136), // "Fecha no válida.", 
                { variant: "error" });
            return false;
        }

        if (horariosAreaServicio.length) {
            let horaEntradaAreaServicio = new Date(actualDate.getFullYear(), Number(actualDate.getMonth() + 1), actualDate.getDate(), new Date(horariosAreaServicio[0]['horaEntrada']).getHours(), new Date(horariosAreaServicio[0]['horaEntrada']).getMinutes());
            let horaSalidaAreaServicio = new Date(actualDate.getFullYear(), Number(actualDate.getMonth() + 1), actualDate.getDate(), new Date(horariosAreaServicio[0]['horaSalida']).getHours(), new Date(horariosAreaServicio[0]['horaSalida']).getMinutes());

            //NO CUENTA VENTANA FIJA-SIN FRENCUENCIA SERVICIO
            if (!validaFrencuenciaArea(diaSemana)) {
                let error = traducirMessage(43).replace('#####', areaServicioRemitente.nombre).replace('#####', getDiasServiciosArea());
                //`El área de servicio ${areaServicioRemitente.nombre} solo cuenta con servicio los días ${getDiasServiciosArea()}. Favor de seleccionar otra fecha.`
                enqueueSnackbar(error, {variant: "error"});
                return;
            }

            //NO CUENTA VENTANA FIJA-EXCEDIO HORARIO DEL AREA DE SERVICIO
            if (selectedDateNumber == actualDate.getDate() && (horaUsuario > horaSalidaAreaServicio || horaUsuario < horaEntradaAreaServicio)) {
                let hi = new Date(horaEntradaAreaServicio).toLocaleString('es', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                });
                let hf = new Date(horaSalidaAreaServicio).toLocaleString('es', {
                    hour: '2-digit',
                    minute: '2-digit',
                    hour12: false
                });
                let error = traducirMessage(44).replace('#####', areaServicioRemitente.nombre).replace('#####', hi).replace('#####', hf);
                //`El área de servicio ${areaServicioRemitente.nombre} solo permite la recolección entre las ${hi} - ${hf}. Favor de revisar con el administrador.`
                enqueueSnackbar(error, {variant: "error"});
                return;
            }
        }

        onSave(new Date(selectedDate));
    };

    const validaFrencuenciaArea = (dia) => {
        let valido = false;
        if (horariosAreaServicio.length && horariosAreaServicio[0].dias) {
            valido = horariosAreaServicio[0].dias.filter(s => s.id == dia).length == 1;
            if(!valido && horariosAreaServicio.length>1)
            {
                valido = horariosAreaServicio[1].dias.filter(s => s.id == dia).length == 1;
            }
        }
        return valido;
    }
    const getDiasServiciosArea = (): string => {
        let dias: string[] = [];

        areaServicioRemitente.horarios?.forEach(h => {
            h.dias.forEach(d => {
                dias.push(d.nombre);
            })
        })

        return dias.join(", ");
    }
    const getVentajaFija = (date) => {
        if(aplicaReglasVentana)
        {
            const day = date.getDay();
            if(day === 1 && ventanaFija.lun===1
                || day === 2 && ventanaFija.mar===1
                || day === 3 && ventanaFija.mie===1
                || day === 4 && ventanaFija.jue===1
                || day === 5 && ventanaFija.vie===1
                || day === 6 && ventanaFija.sab===1
                || day === 0 && ventanaFija.dom===1
            )
                return false
            else
                return true;
        }
        else
            return  false;

    };

    const getDiasFestivos = async () => {
        const result = await apiSource.postAsync<any>("solicitud-servicio/obtener-dias-festivos",{username: localStorage.getItem("usuario_nombre")});
        return result;
    };

    const esDiaFeriado = (date) => {
        date.setHours(0, 0, 0, 0);
        let esFestivo = false;
        const diaSemana = date.getDay();
 
        // Deshabilitar el sábado actual
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0);
        if (diaSemana === 6 && date.getTime() === hoy.getTime() && hoy.getDay() === 6) {
            return true;
        }

        if (esSolicitud && !esOrigen) {
            const paramSabado = parametrosFinSemana.find(p => p.parametroId === 73);
            const paramDomingo = parametrosFinSemana.find(p => p.parametroId === 74);

            // Si es sábado y el valor NO es "1", entonces es festivo
            if (diaSemana === 6 && paramSabado?.valor !== "1") {
                return true;
            }

            // Si es domingo y el valor NO es "1", entonces es festivo
            if (diaSemana === 0 && paramDomingo?.valor !== "1") {
                return true;
            }
        }
        else if(!esSolicitud && (diaSemana === 0 || diaSemana === 6)) {
            return true;
        }
        
        arrayDiasFestivos.forEach(dia => {
        if (date.getTime() === dia.getTime()) {
            esFestivo = true;
        }
        });
        return esFestivo;
      };

    return (<>
        <Dialog open={abierto} maxWidth="sm" fullWidth={true}>
            <DialogTitle id="simple-dialog-title">
                {/* Selecciona la fecha y hora de {esOrigen ? 'recolección' : 'entrega'} */}
                {esOrigen ? traducirMessage(239) : traducirMessage(238)}
            </DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid item xs>
                        <DialogContentText>
                        {localStorage.getItem("idioma") === 'en-US' &&
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={us}>
                                <DateTimePicker
                                    label={traducirLabel(129)}
                                    InputProps={{ inputProps: { min: minDate } }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={selectedDate}
                                    onChange={(newValue) => handleDateTimeChange(newValue != null ? newValue.toString() + ' ' + newValue.getHours() : '')}
                                    format={'MM-dd-yyyy HH:mm'}
                                    shouldDisableDate={date => esDiaFeriado(date)}
                                />
                            </MuiPickersUtilsProvider>
                        }
                        {localStorage.getItem("idioma") !== 'en-US' &&
                            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={es}>
                                <DateTimePicker
                                    label={traducirLabel(129)}
                                    InputProps={{ inputProps: { min: minDate } }}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={selectedDate}
                                    onChange={(newValue) => handleDateTimeChange(newValue != null ? newValue.toString() + ' ' + newValue.getHours() : '')}
                                    format={'dd-MM-yyyy HH:mm'}
                                    shouldDisableDate={date => esDiaFeriado(date)}
                                />
                            </MuiPickersUtilsProvider>
                        }
                        </DialogContentText>
                    </Grid>
                    <Grid item alignContent="center" xs>
                        <Box className="title-4 text-center" fontWeight="bold">
                            {horarios?.map((h, i) => <div key={i}>{h}</div>)}
                        </Box>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={saveDate} variant="contained" color="primary">
                    {/* Guardar */
                    traducirButton(12)}
                </Button>
                <Button onClick={onClose} variant="contained">
                    {/* Cerrar */
                    traducirButton(16)}
                </Button>
            </DialogActions>
        </Dialog>
        {
            showLoading &&
            <>
                <LoadingDialog titulo={traducirLabel(240)/* Procesando */} abierto={true} />
            </>
        }
    </>)
};

const mapStateToProps = (state: ApplicationState) => ({
    diasFestivos: state.diasFestivos
});


export default connect(mapStateToProps)(PickUpDate);

//export default PickUpDate;
